import type {ReactElement} from 'react';
import {Button, IconPlacement, ButtonType, ButtonSize} from '@Components/button';
import {openSocialAccountsUpsellDialogFromNestedControl} from '@Libraries/social-media-account.library';
import type {PlanLockedUpgradeButtonProps} from './plan-locked-upgrade-button.types';
import {PLAN_LOCKED_UPGRADE_ICON} from './plan-locked-upgrade-button.types';

/** Stands in for "Fix this" on a plan-locked account: reconnecting cannot make it postable, only upgrading can. */
export function PlanLockedUpgradeButton({variant = 'secondary', isFullWidth = false, customClasses}: PlanLockedUpgradeButtonProps): ReactElement {
  return (
    <Button
      type={variant === 'primary' ? ButtonType.PRIMARY : ButtonType.SECONDARY}
      size={ButtonSize.MEDIUM}
      icon={PLAN_LOCKED_UPGRADE_ICON}
      iconPlacement={IconPlacement.LEFT}
      text={window.i18next.t('pmwjs_upgrade')}
      onClick={openSocialAccountsUpsellDialogFromNestedControl}
      isFullWidth={isFullWidth}
      customClasses={customClasses}
    />
  );
}
